export class GapCompareModel {

    poNumber: string;
    color: string;
    size: string;
    oldPrice: string;
    newPrice: string;
    olddeliveryDate: string;
    newdeliveryDate: string;
    oldQuantity: number;
    newQuantity: number;
    oldtransMode: string;
    newtransMode: string;
    olddeliveryAddress: string;
    newdeliveryAddress: string;


    constructor(poNumber: string, color: string, size: string,
        oldPrice: string,
        newPrice: string,
        olddeliveryDate: string,
        newdeliveryDate: string,
        oldQuantity: number,
        newQuantity: number,
        oldtransMode: string,
        newtransMode: string,
        olddeliveryAddress: string,
        newdeliveryAddress: string,

    ) {

        this.poNumber = poNumber
        this.color = color
        this.size = size
        this.oldPrice = oldPrice
        this.newPrice = newPrice
        this.olddeliveryDate = olddeliveryDate
        this.newdeliveryDate = newdeliveryDate
        this.oldQuantity = oldQuantity
        this.newQuantity = newQuantity
        this.oldtransMode = oldtransMode
        this.newtransMode = newtransMode
        this.olddeliveryAddress = olddeliveryAddress
        this.newdeliveryAddress = newdeliveryAddress

    }

}